import React, { useReducer, useContext, useState } from 'react';

import FormInput from '../FormInput/FormInput';
import Alert from '../Alert/Alert';
import { AuthContext } from '../../context/auth/authContext';
import Spinner from '../Spinner/Spinner';
import { useAlert } from '../Alert/useAlert';
import { NavLink } from 'react-router-dom';

const ForgetPasswordForm = () => {
	const { handleRestorePassword, isUserLoading } = useContext(AuthContext);
	const [alert, showAlert, hideAlert] = useAlert();
	const [email, setEmail] = useState('');
	const [loginAlert, setLoginAlert] = useState(false);

	const handleOnChange = event => {
		const { value } = event.target;

		setEmail(value);
	};

	const handleSubmit = async event => {
		event.preventDefault();

		const res = await handleRestorePassword(email, showAlert, hideAlert);
		setEmail('');

		if (res) {
			setLoginAlert(true);
		}

	};

	return (
		<form className="page_form" onSubmit={handleSubmit}>
			{alert.visible ? (
				<Alert
					alert={alert}
					hide={hideAlert}
				/>
			) : null}
			{!loginAlert ? (
				<React.Fragment>
					<ul className="form_field_list">
						<li className="form_field_item">
							<FormInput
								title="User Email"
								id="email"
								type="text"
								name="email"
								placeholder="Email"
								value={email}
								required={true}
								onChange={handleOnChange}
							/>
						</li>
					</ul>
					<div className="form_btn_w center_level_mod">
						<button
							className="btn_v2 full_mod"
							type="submit"
							value="Submit"
							disabled={isUserLoading}
						>
							{isUserLoading ? (
								<Spinner />
							) : 'Submit'}
						</button>
					</div>
				</React.Fragment>
			) : (
					<div className="form_btn_w center_level_mod">
						<NavLink className="btn_v2 full_mod" to="/login">Sign In</NavLink>
					</div>
				)}
		</form>
	);
}
export default ForgetPasswordForm;